import * as types from './mutation-types'

import {
  _saveRole,
  _saveSurveyRole,
  set_Attention,
  get_Attention,
  set_GuidePage,
  get_GuidePage,
  get_SurveyType,
  set_SurveyType
} from '../utils/cache'

import http from "../utils/http";

import { MSG } from "../utils/utils";

export const saveRole = function ({
  commit
}, payload) {
  _saveRole(payload)
  commit(types.SET_ROLE, payload)
}

export const saveSurveyRole = function ({
  commit
}, payload) {
  _saveSurveyRole(payload)
  commit(types.SET_SURVEY_ROLE, payload)
}

export const setAttention = function ({
  commit
}, payload) {
  set_Attention(payload)
  commit(types.SET_ATTENTION, payload)
}

export const getAttention = function ({
  commit
}) {
  commit(types.SET_ATTENTION, get_Attention())
}


export const setGuidePage = function ({
  commit
}, payload) {
  set_GuidePage(payload)
  commit(types.SET_ATTENTION, payload)
}

export const getGuidePage = function ({
  commit
}) {
  commit(types.SET_ATTENTION, get_GuidePage())
}

export const setSurveyType = function ({
  commit
}, payload) {
  set_SurveyType(payload)
  commit(types.SET_SURVEY_TYPE, payload)
}

export const getSurveyType = function ({
  commit
}) {
  commit(types.SET_SURVEY_TYPE, get_SurveyType())
}

export const getUserInfo = async function ({
  commit
}) {
  return new Promise(async(resolve,reject)=>{
    try {
      const res = await http
        .get(`/survey/userInfo`, {})
      const {
        code,
        data,
      } = res;
      if (code === 1) { 
        window.initWmdaSdk && window.initWmdaSdk(data.uid);
        commit("setUserInfo", data || null);
        localStorage.setItem("survey-user", JSON.stringify(data));
      }
      resolve(res)
    } catch (error) {
      reject(error)
      MSG.error("请登录后重试");
    }
  })
 
}



export const clearAllData = function ({
  commit
}, payload) {

}



// WEBPACK FOOTER //
// ./src/store/actions.js